import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { MatchMapVetoContext } from 'components/MatchMapVetos/__MatchMapVetos.context'

const MatchMapVetos: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.MatchMapVetoParams>()

  return (
    <MatchMapVetoContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </MatchMapVetoContext.Provider>
  )
}

export default MatchMapVetos
